import client from './client'
import type { PaginatedResponse } from '@/types/shared'
import type {
  AdminAuditLogEntry,
  FeeOverridePayload,
  OrganisationFeeOverride,
  PlatformPricing,
  UpdatePlatformPricingPayload,
} from '@/types/pricing'

export interface FetchSettingsHistoryParams {
  page?: number
  per_page?: number
  action?: string
}

export async function fetchPlatformPricing(): Promise<PlatformPricing> {
  const { data } = await client.get<{ data: PlatformPricing }>('/admin/pricing')
  return data.data
}

export async function updatePlatformPricing(
  payload: UpdatePlatformPricingPayload,
): Promise<PlatformPricing> {
  const { data } = await client.put<{ data: PlatformPricing }>('/admin/pricing', payload)
  return data.data
}

export async function fetchSettingsHistory(
  params: FetchSettingsHistoryParams,
): Promise<PaginatedResponse<AdminAuditLogEntry>> {
  const { data } = await client.get<PaginatedResponse<AdminAuditLogEntry>>('/admin/settings/history', {
    params,
  })
  return data
}

export async function fetchOrganisationFeeOverride(organisationId: number): Promise<OrganisationFeeOverride> {
  const { data } = await client.get<{ data: OrganisationFeeOverride }>(
    `/admin/organisations/${organisationId}/fee-override`,
  )
  return data.data
}

export async function updateOrganisationFeeOverride(
  organisationId: number,
  payload: FeeOverridePayload,
): Promise<OrganisationFeeOverride> {
  const { data } = await client.put<{ data: OrganisationFeeOverride }>(
    `/admin/organisations/${organisationId}/fee-override`,
    payload,
  )
  return data.data
}

export async function clearOrganisationFeeOverride(
  organisationId: number,
  reason: string,
): Promise<OrganisationFeeOverride> {
  const { data } = await client.delete<{ data: OrganisationFeeOverride }>(
    `/admin/organisations/${organisationId}/fee-override`,
    { data: { reason } },
  )
  return data.data
}
